import React from 'react';

const ConfirmDeleteModal = ({ onConfirm, onCancel }) => (
  <div className="fixed -inset-8 flex items-center justify-center bg-black bg-opacity-40 z-50">
    <div className="bg-white p-6 rounded-lg shadow-md w-64 md:w-96 text-center">
      <p className="mb-6">Are you sure you want to delete this product?</p>
      <div className="flex justify-center gap-4">
        <button
          className="primary-background white-text px-6 py-1 rounded hover:bg-red-700"
          onClick={onConfirm}
        >
          Yes
        </button>
        <button className="bg-gray-300 px-6 py-1 rounded hover:bg-gray-400" onClick={onCancel}>
          No
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmDeleteModal;
